<div class=" modal-header d-flex justify-content-center bg-light ">
    <h4 class="modal-title strong">Place bid</h4>
</div>
<div class="modal-body bg-light">
    <div class="d-flex align-items-center flex-column">
        <!-- <div class="small text-secondary  small">Material #</div> -->
        <h5 class="strong mb-2">{{a.newName?a.newName:a.productName}}</h5>
        <div class="small text-secondary" *ngIf="( productInfo?.arrivalPeriod == 'true')">{{'tenders.ArrivalPeriod'|
            cxTranslate}}</div>
        <div class="small text-secondary"
            *ngIf="((productInfo.commodityType!='CA') && productInfo?.arrivalPeriod == 'false')">
            {{'tenders.LoadPortLaycan'| cxTranslate}}</div>
        <div class="small text-secondary"
            *ngIf="((productInfo.commodityType=='CA') && productInfo?.arrivalPeriod == 'false')">{{'tenders.schedule'|
            cxTranslate}}</div>
        <div class="small" *ngIf="( productInfo?.arrivalPeriod == 'false')">{{a?.laycanStartDate |
            date:"dd/MM/yyyy"}} - {{a?.laycanEndDate | date:"dd/MM/yyyy"}}</div>
        <div class="small" *ngIf="(productInfo?.arrivalPeriod == 'true')">{{productInfo?.arrivalStartDate |
            date:"dd/MM/yyyy"}} - {{productInfo?.arrivalEndDate | date:"dd/MM/yyyy"}}</div>
        <div class="small text-secondary" *ngIf="productInfo.commodityType=='IO'&& a?.feBasis">{{'tenders.feBasis'|
            cxTranslate}}</div>
        <div class="small" *ngIf="productInfo.commodityType=='IO'&& a?.feBasis">{{a?.feBasis}}</div>

    </div>

    <div class="my-4">
        <div class="small">
            <h6 class="strong"> {{ 'tenders.Quantity(DMT)' | cxTranslate }}({{a.displayQuantityUnitDesc}})</h6>
            <div class="h5 semibold"
                *ngIf="a?.quantity && !a?.minimumQuantity && !a?.maximumQuantity && a.isQuantityUnrestricted== false">
                {{a?.quantity | number}}</div>
            <input type="number" min="0" max="999999" [(ngModel)]="quantityshw" class="form-control"
                *ngIf="a?.quantity && !a?.minimumQuantity && !a?.maximumQuantity && a.isQuantityUnrestricted== true">
            <div *ngIf="a?.pricingOptionsEnum.length>=1 &&  a?.minimumQuantity && a?.maximumQuantity">
                <div>
                    <button class="btn btn-secondary btn-lg custom-button left" [disabled]="value===a.minimumQuantity"
                        (click)="changeQuantity('decrease',5000)"><i class="fa fa-minus"
                            aria-hidden="true"></i></button>
                    <input type="number" class="form-control-lg custom-input" [(ngModel)]="value" disabled>
                    <button class="btn btn-secondary btn-lg custom-button right" [disabled]="value===a.maximumQuantity"
                        (click)="changeQuantity('increase',5000)"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </div>

                <p *ngIf="value===a.maximumQuantity" class="text-primary my-1 md-semibold-font "> Maximum quantity
                    selected.</p>
                <p *ngIf="value===a.minimumQuantity" class="text-primary my-1 md-semibold-font "> Minimum quantity
                    selected.</p>

                <!-- <h5 class="strong" *ngIf="a?.pricingOptionsEnum?.length>=1">{{value}}</h5>
                <input type="range" class="form-range w-100" [min]="a?.minimumQuantity" [max]="a?.maximumQuantity" step="5000" [(ngModel)]="value"> -->
            </div>
        </div>
    </div>

    <div class="form-group" *ngIf="a?.isDischargePortUnrestricted== true">
        <h6 class="strong">{{ 'tenders.DischargePort' | cxTranslate }}</h6>
        <!-- <h5 class="strong" *ngIf=" a?.dischargePortDetails && a.isDischargePortUnrestricted== false">{{a?.dischargePortDetails}}</h5> -->
        <!-- <input type="text" [(ngModel)]="a.dischargePortDetails" class="form-control">     -->
        <input *ngIf="a?.isDischargePortUnrestricted== true" type="text"
            [(ngModel)]="dischargePortshw" class="form-control">
    </div>
    <div *ngFor="let options of a.pricingOptionsEnum">

        <div *ngIf="options.pricingOptions!='FIXED_PRICE' && productInfo.commodityType!='CN'" class="form-group">
            <div *ngIf="productInfo.commodityType!='CA'" class="small text-secondary ">{{'tenders.Pricingbasis' |
                cxTranslate}}</div>
            <div *ngIf="productInfo.commodityType=='CA'" class="small text-secondary ">{{'tenders.OnlyPrice' |
                cxTranslate}}</div>
            <div class=" small" *ngFor="let Pricingbasis of a.pricingBasis">
                {{Pricingbasis?Pricingbasis.description:'--'}}</div>
                <div *ngIf="a.defaultQuotationPeriod?.description!=''" class="form-group">
                    <div class="small text-secondary ">Quotation period</div>
                    <div class=" small" *ngIf="(a.isQuotationPeriodUnrestricted===false && options.isQPMultipleChoicesSelected === false) || (options.isQPMultipleChoicesSelected == true && displayFixedQPSection == true && options.isQuotationPeriodUnrestricted==false)">{{formatQPDates(a)}}</div>
                    <select class="custom-select" (change)="qpChangeAction($event,i, a)" *ngIf=" options.isQPMultipleChoicesSelected === true" [(ngModel)]="defaultValue">
                        <option value="{{qp.description}}" id="{{qp.uniqueRowNumber}}" *ngFor="let qp of options.qpMultipleChoices; let i=index;">{{qp.description}}  </option>
                    </select>
                    <p *ngIf="QPValuSelectedError==true" class="text-danger my-1 md-semibold-font ">{{'home.productHeader.selectQPError'| cxTranslate}}</p>   
            <div class="d-flex row w-100" *ngIf="(a.isQuotationPeriodUnrestricted===true && options.isQPMultipleChoicesSelected == false)  || (options.isQPMultipleChoicesSelected == true && displayFixedQPSection == true &&  options.isQuotationPeriodUnrestricted==true)">
                        <div class="form-group col-md-6 col-sm-12 mb-0">
                            <div for="Select2" class="small strong">From <span class="text-danger">*</span></div>
                            <form role="form" [formGroup]="form" class="inline-filter date-range-picker-form to">
                                <fieldset>
                                    <input [readonly]="true" [minDate]="{year: '', month: '', day: ''}" name="s"
                                        formControlName="finalQPFromDate" id="finalQPFromDate"
                                        [footerTemplate]="footerTemplate1" class="form-control bg-white  ff-normal date-width"
                                        ngbDatepicker #s="ngbDatepicker" (click)="toggle(s)"
                                        (dateSelect)="qpFromDateSelection($event)" />
                                    <ng-template #footerTemplate1>
                                        <hr class="my-0">
                                        <button class="btn btn-secondary btn-sm m-2 float-end "
                                            (click)="s.close()">Close</button>
                                    </ng-template>
                                    <span *ngIf="isFinalQPFromDateValid" class="text-danger validity-date-error"><i
                                            class="fa fa-exclamation-circle error-circle" aria-hidden="true"></i>This
                                        field
                                        is
                                        required</span>
                                </fieldset>
                                <!-- <cx-form-errors [control]="materialform.get('laycanStartDate')"></cx-form-errors> -->
                            </form>
                        </div>
                        <div class="form-group col-md-6 col-sm-12 mb-0">
                            <div for="Select3" class="small strong">To <span class="text-danger">*</span></div>
                            <form role="form" [formGroup]="form" class="inline-filter date-range-picker-form to">
                                <fieldset>
                                    <input [readonly]="true" [minDate]="{year: '', month: '', day: ''}" name="e"
                                        formControlName="finalQPToDate" id="finalQPToDate" [footerTemplate]="footerTemplate2"
                                        class="form-control bg-white  ff-normal date-width" ngbDatepicker #e="ngbDatepicker"
                                        (click)="toggle(e)" (dateSelect)="qpToDateSelection($event)" />
                                    <ng-template #footerTemplate2>
                                        <hr class="my-0">
                                        <button class="btn btn-secondary btn-sm m-2 float-end "
                                            (click)="e.close()">Close</button>
                                    </ng-template>
                                    <span *ngIf="isFinalQPToDateValid" class="text-danger validity-date-error"><i
                                            class="fa fa-exclamation-circle error-circle" aria-hidden="true"></i>This
                                        field
                                        is
                                        required</span>
                                    <span *ngIf="isFinalQPToGreater" class="text-danger validity-date-error"><i
                                            class="fa fa-exclamation-circle error-circle" aria-hidden="true"></i>EndDate
                                        should
                                        be greater than startDate</span>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
        </div>

        
        <div *ngIf="(options.premiumIndex!='' && options.premiumIndex!=undefined)" class="form-group">
            <div class="small text-secondary ">{{'tenders.Premium' | cxTranslate}}</div>
            <div class=" small">
                {{options.premiumIndex}}</div>
        </div>
        <div *ngIf="productInfo.commodityType=='CN' && a.childList==undefined">
            <div class="mb-4">
                <div class="small text-secondary ">Terms & conditions</div>
                <div class=" small">{{productInfo.termsAndConditions?productInfo.termsAndConditions.description:'--'}}
                </div>
            </div>
            <div class="mt-2" *ngIf="options.displayTCPrice == true">
                <h6 class="strong">Enter your TC (per {{options.tcPriceUnitDesc}})</h6>
                <span class="currency-icon position-absolute">USD &nbsp;</span>
                <input type="text" [(ngModel)]="price" (change)="divide()" AllowNegativeDecimalNumber
                    [beforeDecimal]="options.tcBeforeDecimals" [afterDecimal]="options.tcAfterDecimals"
                    class="form-control form-control-lg pl-5" preventCutCopyPaste required #name="ngModel" />
                <p *ngIf="priceEmpty==true" class="text-danger my-1 md-semibold-font ">Please enter your price.</p>
            </div>
            <div *ngIf="options.displayRCPrice == true">
                <h6 class="strong mt-2 ">Enter your RC (per {{options.rcPriceUnitDesc}} of payable
                    Copper)</h6>
                <span class="currency-icon position-absolute">USD &nbsp;</span>
                <input [(ngModel)]="indexPrice" disabled class="form-control form-control-lg pl-5" required
                    #name="ngModel" />
            </div>
        </div>
        <div *ngIf="productInfo.commodityType!='CN'  && a.childList==undefined">
            <div class="form-group">

                <div *ngIf="options.displayPrice==true">
                    <h3 class="strong h6">{{getLabel(options,productInfo.commodityType) | cxTranslate}}{{getUnit(options,productInfo.commodityType)}}</h3>
                    <span class="currency-icon position-absolute">{{getPrefix(options,productInfo.commodityType)}}
                        &nbsp;</span>
                    <input [(ngModel)]="priceModel" appCommonDigitsDirective [beforeDecimal]="options.beforeDecimals"
                        [afterDecimal]="options.afterDecimals" [pricingOptions]="options.pricingOptions" [commodityType]="productInfo.commodityType" class="form-control form-control-lg pl-5"
                        preventCutCopyPaste #name="ngModel" required />
                    <p *ngIf="IndexPriceEmpty==true || FixedPriceEmpty==true" class="text-danger my-1 md-semibold-font ">Please enter your price.</p>
                </div>
            </div>
        </div>

    </div>
    <div *ngIf="productInfo.commodityType=='CC' && a?.childList">
        <div class="form-group" *ngFor="let row of a?.childList">
            <div *ngFor="let priceOptions of row.pricingOptionsEnum">
                <div *ngIf="priceOptions.displayPrice==true">
                    <h6> {{row.productName}} price (per {{priceOptions.priceUnitDesc}})</h6>
                    <span class="currency-icon position-absolute">USD
                        &nbsp;</span>
                    <input [(ngModel)]="row.price" appTwoDigitDecimaNumber [beforeDecimal]="priceOptions.beforeDecimals"
                        [afterDecimal]="priceOptions.afterDecimals" class="form-control form-control-lg pl-5"
                        preventCutCopyPaste #name="ngModel" />
                    <p *ngIf="row.priceEmpty==true" class="text-danger my-1 md-semibold-font ">Please enter your price.
                    </p>
                    <span *ngIf="isHidden" class="tooltip_msg" id="differential_values">enter your price e.g. 97.5% or
                        102.5% </span>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="modal-footer bg-light">
    <div class="w-100">
        <button class="btn btn-block btn-primary btn-lg" type="submit"
            (click)="Openmodal()">{{'tenders.Next'|cxTranslate}}</button>

        <button class="btn btn-block btn-light btn-lg" type="button" (click)="close()">{{ 'home.productHeader.Close' |
            cxTranslate }}</button>
    </div>
</div>